import BaseLoginDao from './BaseLoginDao';
import http from 'hub-http/clients/noAuthApiClient';

class LoginDao extends BaseLoginDao {
  googleLogin(credentials) {
    return this.loginAtPath('/login-api/v1/google', credentials);
  }

  microsoftLogin() {// TODO implement async call for microsoft
  }

  uiLogin(credentials) {
    return this.loginAtPath('/login-api/v1/login?src=ui', credentials);
  }

  userTrustTokenLogin(credentials) {
    return this.loginAtPath('/login-api/v1/login/trust-token', credentials);
  }

  hubUserTrustTokenLogin(credentials) {
    return this.loginAtPath('/login-api/v1/login/trust-token/hub-user', credentials);
  }

  getLoginRequirement(data) {
    return http.post(`/login-api/v1/login-requirements`, {
      data: {
        email: data.email
      }
    });
  }

  getLoginRequirementWithPortal(data, queryData) {
    return http.post(`/login-api/v1/login-requirements/portal-id/${queryData.loginPortalId}`, {
      data: {
        email: data.email
      }
    });
  }

}

export default LoginDao;